import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Sparkles, ThumbsUp, ThumbsDown } from "lucide-react";

// Grounded AI review summary. Renders only when there are enough genuine reviews AND the AI
// produced a summary from them — never fabricates. Silent otherwise.
export const ReviewSummary = ({ productId, serviceId }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const id = productId || serviceId;
    if (!id) return;
    const qs = productId ? `product_id=${productId}` : `service_id=${serviceId}`;
    api.get(`/marketplace/public/reviews/summary?${qs}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [productId, serviceId]);

  if (!data || !data.enough || !data.summary) return null;
  return (
    <div className="rounded-2xl border border-violet-100 bg-violet-50/40 p-4" data-testid="review-summary">
      <p className="mb-2 flex items-center gap-1.5 text-sm font-bold text-slate-900">
        <Sparkles className="h-4 w-4 text-violet-600" /> What reviewers say
        <span className="ml-1 rounded-full bg-white px-2 py-0.5 text-[10px] font-semibold text-slate-500">from {data.count} reviews · {data.avg}★</span>
      </p>
      <p className="text-sm text-slate-700" data-testid="review-summary-text">{data.summary}</p>
      {(data.pros?.length || data.cons?.length) ? (
        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          {data.pros?.length ? (
            <div data-testid="review-summary-pros"><p className="mb-1 flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-emerald-600"><ThumbsUp className="h-3 w-3" /> Liked</p><ul className="space-y-0.5 text-xs text-slate-600">{data.pros.map((p, i) => <li key={i}>· {p}</li>)}</ul></div>
          ) : null}
          {data.cons?.length ? (
            <div data-testid="review-summary-cons"><p className="mb-1 flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-rose-500"><ThumbsDown className="h-3 w-3" /> Watch-outs</p><ul className="space-y-0.5 text-xs text-slate-600">{data.cons.map((c, i) => <li key={i}>· {c}</li>)}</ul></div>
          ) : null}
        </div>
      ) : null}
      <p className="mt-3 text-[10px] text-slate-400">AI summary of genuine customer reviews.</p>
    </div>
  );
};

export default ReviewSummary;
